/*
 * Lib Module Hashs
 */

Lib.Hash = (function () {
    var self = {};


    /**
     * CakePHP Hash::Get
     * @param obj
     * @param key
     * @param def
     * @returns {*}
     */
    self.get = function (obj, key, def) {
        var found = key.split(".").reduce(function (o, x) {
            return (typeof o === "undefined" || o === null) ? o : o[x];
        }, obj);

        return found || def;
    };

    return self;

})();
